import { render, staticRenderFns } from "./NotificationCenterMenu.vue?vue&type=template&id=110db898&scoped=true&"
import script from "./NotificationCenterMenu.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterMenu.vue?vue&type=style&index=0&id=110db898&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110db898",
  null
  
)

export default component.exports